<template>
  <div class="login-wrap">
    <!-- <img class="login-back" :src="backImg"> -->
    <div class="login-back"></div>
    <div class="check-wrap" v-show="isCheckShow">
        <div class="check-body">
          <div>
            <el-form ref="checkform" :model="checkform" :rules="rules" label-width="80px">
              <el-form-item label="" prop="name">
                <el-input clearable v-model="checkform.name" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item label="" prop="password">
                  <div class="input_group">
                      <!-- 输入框 -->
                      <el-input class="sms-input" v-model="checkform.password" placeholder="请输入验证码"></el-input>
                      <!-- 输入框后面的内容 -->
                      <div class="sms-title" style="color:blue"  @click="sendLoginSms" v-if="(count==60 || count==-1)" >获取验证码</div>
                      <div class="sms-title" v-else><span style="color: red;">{{count}}s</span>后重新发送</div>
                  </div>
              </el-form-item>
             <el-form-item label="" prop="type">
                <el-select
                v-model="checkform.type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in userTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
              <el-form-item>
                <el-button style="width: 100%" type="primary" @click="onSubmit('checkform')">登录</el-button>
              </el-form-item>
            </el-form>  
          </div>
        </div>
      
    </div>
  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      backImg: require('@/assets/login-back.jpeg'),
      isCheckShow: false,
      checkform: {
        name: '',
        password: '',
        type: 1
      },
      userTypeList:[{id:1,name:'管理员和商户'},{id:3,name:'城市经理'},{id:7,name:'回收商管理员'}],
      show: true,
      count: 60,
      timer: null,
      menus: null,

      rules: {
        name: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
      }
    }
  },
  watch:{},
  computed:{},
  methods:{
    sendLoginSms(){
      if(this.checkform.name==''){
          this.$message({
          message: "账号为空",
          type: "error",
        });
        return
      }
      this.$api.sendSms({username:this.checkform.name,type:1,wxSource:0})
      .then((res)=>{
         if(res.code==200){
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                this.count=60;
              }
            }, 1000)
          }
         }
      })


     
    },
    //背景图加载
    load(){
      let self = this;
      let img = new Image();
      let backImg = require('@/assets/login-back.jpeg')
      // console.log(backImg)
      img.src = backImg
      img.onload = function() {
        // console.log('img is loaded')
        self.backImg = backImg
        self.isCheckShow = !self.isCheckShow
      };
    },

    formvalidate(formName, cb){
       // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          cb()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     },

    // 登录
    onSubmit(formName) {
      let self = this;
      self.formvalidate(formName, () => {
        self.$api.login({
          username: self.checkform.name,
          password: self.checkform.password,
          type: self.checkform.type,
        }).then(res => {
          if(res.code === 200) {
            console.log(res,'res---------')
            localStorage.setItem('userInfo', JSON.stringify(res))
            // self.$router.push({path: '/index/order'})
            if(self.checkform.type==3){
              location.href = 'index/consignManage/orderManage'
            }else if(res.data.roleId == 5){
              location.href = '/index/home'
            }else if(res.data.roleId == 10){
              location.href = '/index/qualityInspection'
            }else if(res.data.roleId == 9){
              location.href = '/index/orderHistory'
            }else{
              location.href = '/index/order'
            }
            
          }
        })
      })
    }
  },
  created(){},
  mounted(){
    this.load()
    
  }
}
</script>
<style lang="less" scoped>

   .input_group{
      background: white;
      display: flex;
   }

   .sms-input /deep/ .el-input__inner{
     border: none;
     border-radius:0;
     
   }

   .sms-title{
     padding: 0 10px;
     word-break:keep-all;      /* 不换行 */
     white-space:nowrap;       /* 不换行 */
     text-align: center;
   }


  .login-wrap {

    .login-back {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 50%;
      background-image: url('../../src/assets/login-back.png');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  .check-wrap {
    position: absolute;
    background-color: #000;
    height: 100%;
    width: 50%;
    top: 0;
    left: 50%;
    bottom: 0;
    right: 0;
    margin: auto;

    .check-body {
      width: 100%;
      height: 100%;
      position: relative;

      >div{
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        height: 200px;
        width: 500px;
      }
    }
  }
</style>